import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose } from "../../components/v2/icons";
import { Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper } from "./layout.c";
import { UI } from '../../../core/ui';
import { Select } from '@lib/components/src';


interface Props extends WithTranslation {}
interface State {
    toggle: boolean;
    version?: string;
    menu_api: 'standard' | 'original';
}

@inject("store") @observer
class QuickSettingsClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
        this.state = {
            toggle: false,
            version: 'v1',
            menu_api: 'standard'
        };
	}

    componentDidMount(): void {
        const { organisation } = this.injected.store
        this.setState({
            toggle: (organisation!.dashboard == 'v2'),
            version: organisation!.dashboard,
            menu_api: organisation!.menu || 'original'
        })
    }

    render() {
        const { store, t} = this.injected;
        const { organisation } = store;
        if(!organisation) return
        return (
        <QuickSettingsContainer className={store.view.quicksettings_active ? 'active': ''}>
            <QuickSettingsHeaderWrapper>
                <HeaderTitleWrapper style={{justifyContent: 'start'}}>
                    <IconSettings />
                    <div>Quick Settings</div>
                </HeaderTitleWrapper>
                <MenuItem onClick={() => store.updateView({quicksettings_active: false})}><IconClose /></MenuItem>
            </QuickSettingsHeaderWrapper>
            <QuickSettingsBodyWrapper>
                <QuickSettingsItemsContainer>
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Choose Layout</span>

                            <Select
                                value={this.state.version}
                                options={[
                                    {label: 'Classic', value: 'v1'},
                                    {label: 'Modern 1', value: 'v2'},
                                    {label: 'Modern 2', value: 'v2.1'},
                                ]}
                                onChange={(e) => {
                                    this.setState({
                                        version: e.target.value
                                    })
                                  if (e.target.value === 'v2.1') {
                                    this.setState({ menu_api: 'standard' })
                                  } else {
                                    this.setState({ menu_api: 'original' })
                                  }
                                }}/>
                        </QuickSettingsItemWrapper>
                        {organisation && (organisation.dashboard === undefined || organisation.dashboard == 'v1') &&
                        <p>Ordering dashboard is currently using the classic layout.</p>}
                    </QuickSettingsItemsWrapper>
                    {this.state.version === 'v2.1' && <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Menu API</span>

                            <Select
                                value={this.state.menu_api}
                                options={[
                                    {label: '1.0', value: 'original'},
                                    {label: '2.0', value: 'standard'},
                                ]}
                                onChange={(e) => {
                                    this.setState({
                                        menu_api: e.target.value as 'standard' | 'original'
                                    })
                                }}/>
                        </QuickSettingsItemWrapper>
                        <p>Ordering dashboard is currently using the {this.state.menu_api} menu schema.</p>
                    </QuickSettingsItemsWrapper> }
                </QuickSettingsItemsContainer>
            </QuickSettingsBodyWrapper>
            <QuickSettingsFooterWrapper>
                <QuickSettingsButton
                    onClick={() => {
                        store.updateView({quicksettings_active: false})
                        store.updateOrganisation({
                            dashboard: this.state.version,
                            menu: this.state.menu_api
                        })
                        store.api.organisation_update({
                            _id: organisation._id,
                            update: {
                                $set: {
                                    dashboard: organisation.dashboard,
                                    menu: this.state.menu_api
                                }
                            }
                        }).then(() =>  UI.notification.success("Settings updated") )
                    }}>
                    Save Settings
                </QuickSettingsButton>
            </QuickSettingsFooterWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const QuickSettings = withTranslation()(QuickSettingsClass);
